export const DEFAULT_FONT_SIZE = 16;

export const pxScaled = (px: number): string => {
  const factor = px / DEFAULT_FONT_SIZE;
  return `calc(var(--font-size-base) * ${factor})`;
};
